"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Replace the last occurrence for the the give needle
*
* @param  string needle
* @param  string replacement
* @return string
*/
function replaceLast(string, needle, replacement) {
    var lastIndex = string.lastIndexOf(needle);
    if (lastIndex < 0) {
        return string;
    }
    return string.substr(0, lastIndex) + replacement + string.substr(lastIndex + needle.length);
}
exports.default = replaceLast;
;
//# sourceMappingURL=replaceLast.js.map